import React, { Component } from 'react';
import { Redirect, Route, NavLink, Link, Switch } from 'react-router-dom';
import superagent from 'superagent';
import ReactLoading from 'react-loading';


class ForgotPassword extends Component {
    constructor(props) {
        super(props);

        this.resetPassword = this.resetPassword.bind(this);
        this.updateAnumber = this.updateAnumber.bind(this);



         this.state={
            collapse: false,
            showError: false,
            loading: false,
            logged_in:true,
            access_token:"",
            user_details:{},
            authentication_error: false,
            valid_anumber:false,
            valid_password: false,
            validation_message:"",
            error_message:"Login failed. Please enter valid credentials.",
            anumber_error_message:"Staff number required",
            password_error_message: "password required",
            display_anumber_error:false,
            display_password_error:false,
            anumber: "",
            password: ""

         }
      }




    resetPassword() {
        if(this.state.valid_anumber)
        {
                this.setState({loading:true});
                const _this = this;
                const url = this.props.base_url +"/staff/forgot_password"

                const url_to_send = "http://localhost:3000" + "/staff/setnewpassword";

                superagent
                .post(url)
                .send({admission_number:_this.state.anumber, base_url:url_to_send})
                .set('Accept', 'application/json')
                .set('Content-Type', 'application/json')
                .then(function(res){
                    //res.body, res.headers, res.status
                    const error = res.body.error;


                    if(!error)
                    {

                    }
                    else
                    {
                        const error_response_message = res.body.message;
                        _this.setState({loading:false, authentication_error:true, error_message:"Server Error"});
                    }

                })
                .catch(function(err){

                    const error_response_message = err +".\n\n Please contact system admin to allow your IP access.";
                    _this.setState({loading:false, authentication_error:true, error_message:error_response_message});
                });


        }

        else
        {
            this.setState({display_anumber_error:true});

        }
      }

      updateAnumber(event) {
        event.preventDefault();

        const anumber_value = event.target.value;
        if(0 === anumber_value.length)
        {
            this.setState({anumber:anumber_value, valid_anumber:false, anumber_error_message:"Please enter staff number",display_anumber_error:true})
        }
        else
        {
            this.setState({email:anumber_value, valid_anumber:true, anumber_error_message:"", display_anumber_error:false})
        }

      }





      renderLoadingProgress()
      {
          if(this.state.loading)
          {
              return(
                <div className="loading-progress">
                <div >
                    Loading, Please wait......
                    <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
                </div>
            </div>

              );
          }
          else{
              return null;
          }
      }

      renderAnumberError()
      {
          if(this.state.display_anumber_error && !this.state.valid_anumber)
          {
            return(<div className="error-block"><p className="validation-error">{this.state.anumber_error_message}</p></div>);
          }
          else
          {
            return null;
          }
      }



      renderErrorMessage()
      {
          if(this.state.authentication_error && !this.state.loading)
          {
              return(
                <div className="loading-progress">
                    <div className="error-message">
                        <p>{this.state.error_message}</p>
                    </div>
                </div>
              );
          }
          else
          {
            return null;
          }

      }




  render() {

    const _this = this;

    return (

        <form className="form login-form" method="" action="">

                  <div className="card card-login">


                    <div margin-top="-60px" className="card-header-login card-header card-header-rose text-center ">
                        <div style={{top:0}} className="cont-center">
                            <Link  to="/"><img src="/img/logotuc.png" alt="logo" height="120"/></Link>
                        </div>

                        <h4 className="card-title">Forgot Password - Staff Account</h4>
                        {this.renderLoadingProgress()}
                        {this.renderErrorMessage()}
                    </div>
                    <div className="card-body ">

                    <p className="text-center">
                        Please enter your Staff Number. You will be sent a link, which you will use to set a new password.
                    </p>


                      <span className="bmd-form-group">
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text">
                              <i className="material-icons">email</i>
                            </span>
                          </div>
                          <input type="text" onChange={_this.updateAnumber.bind(_this)} disabled={this.state.loading} className="form-control" placeholder="Admission Number"/>
                        </div>
                        {this.renderAnumberError()}
                      </span>

                    </div>
                    <div className="card-footer justify-content-center">
                      <button type="submit" onClick={_this.resetPassword.bind(_this)} disabled={this.state.loading}  className="btn btn-green">SEND LINK<div className="ripple-container"></div></button>
                    </div>

                    <div className="card-footer justify-content-center">

                      No, I remember my password. <Link to="/staff/login" >Login</Link>
                    </div>

                    <div margin-bottom="10px" className="card-footer justify-content-center">

                      Not yet registered?  <Link to="/staff/register" >  Create Account</Link>
                    </div>

                  </div>
        </form>



    );
  }
}

export default ForgotPassword;
